export default function withProbability(probability) {
  return (Math.random() > (1 - probability));
}



// WEBPACK FOOTER //
// ./src/lib/withProbability.js